import { Alert } from '@root/components'
import { appendParams, getWorkflowBuilderPageUrl } from '@root/constants'
import { useBusinessContext } from '@root/context'
import { useWorkflow } from '@root/query'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface Props {
  workflowId: number
  nodeUuid?: string | null
}

const WorkflowMatchedCard: React.FC<Props> = ({ workflowId, nodeUuid }) => {
  const [t] = useTranslation()
  const { slug } = useBusinessContext()
  const { data: workflow } = useWorkflow(workflowId)
  const workflowName = workflow?.name?.trim() || '…'

  const workflowUrl = appendParams(getWorkflowBuilderPageUrl(slug, workflowId), {
    ...(nodeUuid ? { node: nodeUuid } : {})
  })

  return (
    <Alert
      type="info"
      marginBottom={0}
      title={t('settings.automation.accountingRules.form.workflowMatchedTitle')}
      description={
        <>
          <Trans
            i18nKey="settings.automation.accountingRules.form.workflowMatchedBody"
            values={{ name: workflowName }}
            components={{ b: <b /> }}
          />{' '}
          <Link to={workflowUrl}>{t('settings.automation.accountingRules.form.workflowOpen')}</Link>
        </>
      }
    />
  )
}

export default WorkflowMatchedCard
